import React, { useEffect } from "react";

const MapModal = ({ open, onClose, query, title }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    if (open) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  const src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
  const link = `https://maps.google.com/?q=${encodeURIComponent(query)}`;

  return (
    <div className="modal-backdrop" onClick={onClose} data-testid="map-modal">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h4 className="modal-title">{title}</h4>
        <div className="modal-map">
          <iframe
            title={title}
            src={src}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
        <a className="textlink modal-link" href={link} target="_blank" rel="noreferrer">
          Open in Google Maps →
        </a>
      </div>
    </div>
  );
};

export default MapModal;
